export default __webpack_public_path__ + "static/2_33-9510d8f920e99286d0f46c343a561086.png";